

export function getFormType() {
  return custemRequest({
    url: 'dict/formType',
    method: 'get'
  })
}

export function getDictConfig() {
  return custemRequest({
    url: 'dict/config',
    method: 'get'
  })
}

export function getDictConfigIdService() {
  return custemRequest({
    url: 'dict/config/id',
    method: 'get'
  })
}

export function getDictList(dictId, index) {
  return custemRequest({
    url: 'dict/list',
    method: 'get',
    params: {
      dictId: dictId,
      index: index
    }
  })
}
export function getLinkList(dictId, pId, index) {
  return custemRequest({
    url: 'dict/link/list',
    method: 'get',
    params: {
      dictId: dictId,
      index: index,
      pId: pId
    }
  })
}


export function getDictIdList(dictId, index) {
  return custemRequest({
    url: 'dict/list/id',
    method: 'get',
    params: {
      dictId: dictId,
      index: index
    }
  })
}

export function getDictListByCode(code, index) {
  return custemRequest({
    url: 'dict/list/code',
    method: 'get',
    params: {
      code: code,
      index: index
    }
  })
}

export function getDictTreeList(dictId, index) {
  return custemRequest({
    url: 'dict/listTree',
    method: 'get',
    params: {
      dictId: dictId,
      index: index
    }
  })
}

//查询子节点数据
export function getDictIdLinkList(dictId,pId,index) {
  return custemRequest({
    url: 'dict/linkList/id',
    method: 'get',
    params: {
      index: index,
      dictId: dictId,
      pId: pId

    }
  })
}
export function getUrlLinkList(url, pId, index) {
  return custemRequest({
    url: url,
    method: 'get',
    params: {
      index: index,
      pId:pId
    }
  })
}


export function getFilesService(recordId){
    return custemRequest({
      url: 'sysFjxxMul/getFiles',
      method: 'get',
      params: {
        'recordId':recordId
       }
    })
  }
  
  export function removeFile(id,recordId){
    return custemRequest({
      url: 'upload/remove',
      method: 'post',
      params: {
        'recordId':recordId,
        'id':id
       }
    })
  }





// WEBPACK FOOTER //
// ./src/util/DictUtil.js